module.exports = __webpack_public_path__ + "img/banner.994d8da5.png";